import React from 'react';
import { Participant, Track, TrackPublication } from 'livekit-client';
import { useVideoRenderLogic } from '../hooks/useVideoRenderLogic';
import { ParticipantVideoContent } from '../hooks/useParticipantVideoContent';
import { BasePlaceholderProps } from '../presenters/view';

interface ParticipantVideoProps {
    track: Track | undefined;
    isLocal: boolean;
    isShowVideo: boolean;
    cameraPublication?: TrackPublication;
    participant: Participant;
    objectFit: string;
    placeholder: string;
    withSpeakerPulseAnimation?: boolean;
    onSizeChanged?: (width: number, height: number) => void;
    VideoRenderer: React.ComponentType<{
        track: Track;
        isLocal: boolean;
        $objectFit: string;
        $isReady: boolean;
        participantId: string;
        onSizeChanged?: (width: number, height: number) => void;
    }>;
    Placeholder: React.ComponentType<BasePlaceholderProps>;
    snapshotFirst?: boolean;
}

export const ParticipantVideo = ({
    track,
    isLocal,
    withSpeakerPulseAnimation,
    isShowVideo,
    cameraPublication,
    participant,
    objectFit,
    placeholder,
    onSizeChanged,
    VideoRenderer,
    Placeholder,
    snapshotFirst = false,
}: ParticipantVideoProps) => {
    const { isVideoReady, isVideoLoading, snapshot, shouldShowSnapshotInsteadOfAvatar } = useVideoRenderLogic({
        isShowVideo: Boolean(isShowVideo),
        track,
        cameraPublication,
        participantId: participant.identity,
    });

    return (
        <ParticipantVideoContent
            track={track}
            isLocal={isLocal}
            withSpeakerPulseAnimation={withSpeakerPulseAnimation}
            isShowVideo={Boolean(isShowVideo)}
            isVideoReady={isVideoReady}
            isVideoLoading={isVideoLoading}
            snapshot={snapshot}
            shouldShowSnapshotInsteadOfAvatar={shouldShowSnapshotInsteadOfAvatar}
            objectFit={objectFit}
            participant={participant}
            placeholder={placeholder}
            onSizeChanged={onSizeChanged}
            VideoRenderer={VideoRenderer}
            Placeholder={Placeholder}
            snapshotFirst={snapshotFirst}
        />
    );
};
